import React from 'react';
import {ReactMarkdownProps} from 'react-markdown/lib/ast-to-react';

import {table} from '../Markdown.css';

export const Table = ({children}: ReactMarkdownProps) => {
  return <table className={table}>{children}</table>;
};
